import { Button } from '@/components/ui/button';
import { Ban } from 'lucide-react';

export const BookingHistoryTab = ({ bookingHistory, blockedVisitors, onBlockVisitor }) => {
  if (bookingHistory.length === 0) {
    return (
      <div className="p-6 border" style={{ backgroundColor: '#FFFFFF', borderColor: '#E4E4E7' }}>
        <h2 className="text-xl font-semibold mb-4" style={{ fontFamily: 'Cabinet Grotesk, sans-serif', color: '#09090B' }}>
          Booking History
        </h2>
        <p style={{ fontFamily: 'IBM Plex Sans, sans-serif', color: '#71717A' }}>No bookings recorded yet.</p>
      </div>
    );
  }

  return (
    <div className="p-6 border" style={{ backgroundColor: '#FFFFFF', borderColor: '#E4E4E7' }}>
      <h2 className="text-xl font-semibold mb-4" style={{ fontFamily: 'Cabinet Grotesk, sans-serif', color: '#09090B' }}>
        Booking History
      </h2>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
          <thead>
            <tr className="border-b" style={{ borderColor: '#E4E4E7' }}>
              <th className="text-left py-3 px-2 font-bold" style={{ color: '#71717A' }}>Vehicle</th>
              <th className="text-left py-3 px-2 font-bold" style={{ color: '#71717A' }}>Phone</th>
              <th className="text-left py-3 px-2 font-bold" style={{ color: '#71717A' }}>Spot</th>
              <th className="text-left py-3 px-2 font-bold" style={{ color: '#71717A' }}>Check-In</th>
              <th className="text-left py-3 px-2 font-bold" style={{ color: '#71717A' }}>Amount</th>
              <th className="text-left py-3 px-2 font-bold" style={{ color: '#71717A' }}>Status</th>
              <th className="text-left py-3 px-2 font-bold" style={{ color: '#71717A' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {bookingHistory.map((b) => {
              const isBlocked = blockedVisitors.some(
                bv => (bv.vehicle_number && bv.vehicle_number === b.vehicle_number) ||
                      (bv.phone && bv.phone === b.visitor_phone)
              );
              return (
                <tr key={b.id} className="border-b" style={{ borderColor: '#F4F4F5' }} data-testid={`booking-row-${b.id}`}>
                  <td className="py-3 px-2 font-bold" style={{ fontFamily: 'JetBrains Mono, monospace', color: '#09090B' }}>
                    {b.vehicle_number}
                  </td>
                  <td className="py-3 px-2" style={{ color: '#71717A' }}>{b.visitor_phone}</td>
                  <td className="py-3 px-2" style={{ fontFamily: 'JetBrains Mono, monospace' }}>{b.spot_number}</td>
                  <td className="py-3 px-2" style={{ color: '#71717A' }}>{new Date(b.check_in).toLocaleString()}</td>
                  <td className="py-3 px-2 font-bold" style={{ fontFamily: 'JetBrains Mono, monospace' }}>{'\u20B9'}{b.amount}</td>
                  <td className="py-3 px-2">
                    <span className="text-xs px-2 py-1" style={{
                      backgroundColor: b.status === 'active' ? '#FBBF24' : b.status === 'completed' ? '#10B981' : '#E4E4E7',
                      color: b.status === 'completed' ? '#FFFFFF' : '#09090B',
                      fontFamily: 'IBM Plex Sans, sans-serif'
                    }}>
                      {b.status}
                    </span>
                  </td>
                  <td className="py-3 px-2">
                    {isBlocked ? (
                      <span className="text-xs px-2 py-1 font-bold" style={{ backgroundColor: '#FEE2E2', color: '#DC2626' }}>
                        Blocked
                      </span>
                    ) : (
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => onBlockVisitor(b.vehicle_number, b.visitor_phone, '')}
                        data-testid={`block-visitor-${b.id}`}
                        style={{ borderColor: '#DC2626', color: '#DC2626', fontFamily: 'IBM Plex Sans, sans-serif', fontSize: '12px' }}
                      >
                        <Ban size={12} className="mr-1" /> Block
                      </Button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
